import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const CBCOFNC_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/cbcofnc/logo.png",
        alt: "Carolina Behavioral Care of NC Logo",
        style: { width: "300px", height: "100%", isMobile: { width: "200px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 22,
  state: "NC",
  departmentIds: [119, 121, 126, 146, 249, 250, 251, 262, 270],
};
